import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldProps } from './shared';

export function CheckboxField<
  T extends FieldValues,
  P extends FieldPathByValue<T, boolean>,
>({
  control,
  name,
  rules,
  label,
  description,
  className,
  ...props
}: FieldProps<T, P> & React.ComponentPropsWithoutRef<typeof Checkbox>) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem
          className={cn(
            'grow flex flex-row items-start space-x-3 space-y-0',
            className
          )}
        >
          <FormControl>
            <Checkbox
              checked={value}
              onCheckedChange={onChange}
              {...props}
              {...field}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>{label}</FormLabel>
            <FormDescription>{description?.(value)}</FormDescription>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
}
